"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressDisplayWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@athena-portal/journey-services");
var AddressDisplayWidget = /** @class */ (function (_super) {
    __extends(AddressDisplayWidget, _super);
    function AddressDisplayWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.header = _this.getSetting("header", undefined);
        var address;
        _this.interactionAddress = _this.getSetting("interactionAddress", undefined);
        if (_this.interactionAddress) {
            address = journey_services_1.ObjectManipulator.fetchFieldValue(_this.interactionAddress, _this.props.interaction);
        }
        else {
            throw Error("Address display widget is missing 'interactionAddress' setting");
        }
        _this.state = {
            address: address
        };
        return _this;
    }
    AddressDisplayWidget.prototype.render = function () {
        var capitalize = function (txt) {
            return txt != null ?
                txt.toLowerCase().split(' ').map(function (s) { return s.charAt(0).toUpperCase() + s.substr(1).toLowerCase(); }).join(' ') : "";
        };
        var addressLine1 = "";
        var addressLine2 = "";
        var addressLine3 = "";
        var addressLine4 = "";
        if (this.state.address) {
            addressLine1 = (capitalize(this.state.address.subBuildingName) + " " + capitalize(this.state.address.buildingName)).trim();
            addressLine2 = ((this.state.address.buildingNumber ? this.state.address.buildingNumber : "") + " "
                + capitalize(this.state.address.dependentThoroughfareName ? this.state.address.dependentThoroughfareName + " " : "")
                + capitalize(this.state.address.dependentThoroughfareDescriptor ? this.state.address.dependentThoroughfareDescriptor + " " : "")
                + capitalize(this.state.address.thoroughfareName) + " "
                + capitalize(this.state.address.thoroughfareDescriptor)).trim();
            addressLine3 = (capitalize(this.state.address.doubleDependentLocality ? this.state.address.doubleDependentLocality + "," : "") + " "
                + capitalize(this.state.address.dependentLocality ? this.state.address.dependentLocality + "," : "") + " "
                + capitalize(this.state.address.postTown)).trim();
            addressLine4 = (this.state.address.outwardPostcode + " " + this.state.address.inwardPostcode).trim();
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("h3", { className: "address-title pb-2" }, this.header),
            React.createElement("div", { className: "font-weight-light pb-5", id: "full-address" },
                addressLine1 && React.createElement("div", { id: "address-line-1" }, addressLine1),
                addressLine2 && React.createElement("div", { id: "address-line-2" }, addressLine2),
                addressLine3 && React.createElement("div", { id: "address-line-3" }, addressLine3),
                addressLine4 && React.createElement("div", { id: "address-line-4" }, addressLine4))));
    };
    return AddressDisplayWidget;
}(plugin_journey_1.WidgetBase));
exports.AddressDisplayWidget = AddressDisplayWidget;
//# sourceMappingURL=AddressDisplayWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AddressDisplayWidget.js
// module id = 3201
// module chunks = 0